/**
 * Returns a URL to paste when the clipboard looks like an Edge "copy from
 * address bar" — text/plain is the URL itself, but the html alternative is
 * `<a href="URL">Page Title</a>`. Without intervention Draft.js prefers the
 * html and inserts the title, losing the URL.
 *
 * Returns null for everything else (including ordinary copies of linked text
 * from a page), so default paste behaviour is preserved.
 */
export function getAddressBarPastedUrl(text: string, html?: string): string | null {
    if (!html) {
        return null;
    }

    try {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const anchors = doc.querySelectorAll("a[href]");
        if (anchors.length !== 1) {
            return null;
        }

        const anchor = anchors[0] as HTMLAnchorElement;
        if (anchor.href && text.trim() === anchor.href) {
            return anchor.href;
        }
    } catch {
        // fall through
    }

    return null;
}
